import React from 'react'
import PropTypes from 'prop-types'
import { Columns, Column, Button } from '@resurs/midas-react'
import PageWrapper from '../../../../internal/PageWrapper'
import { getText } from '../../../../internal/TextLabels'
import { rejectedAnimation } from '../../../../assets/animations'

const ApplicationRejectedPage = ({ onCancel, onNext }) => (
  <>
    <PageWrapper type="danger">
      <div
        style={{
          padding: '2rem',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ display: 'flex' }}>
          <img
            style={{ margin: '1rem 1rem 1rem 0' }}
            src={rejectedAnimation}
            alt="Reject animation"
          />
          <h4 style={{ margin: '2.2rem 1rem 0 0' }}>
            {getText('payApply.applicationRejected.title')}
          </h4>
        </div>
        <Columns>
          <Column col6>
            <div style={{ paddingRight: '4rem' }}>
              {getText('payApply.applicationRejected.description')}
            </div>
          </Column>
          <Column col6>
            <Columns>
              <Column col12 noPadding>
                {getText('payApply.applicationRejected.support.title')}
              </Column>
              <Column col12 />
              <Column col6 noPadding>
                {getText('payApply.applicationRejected.support.phone.title')}
              </Column>
              <Column col6 noPadding>
                {getText('payApply.applicationRejected.support.phone.number')}
              </Column>
              <Column col6 noPadding>
                {getText('payApply.applicationRejected.support.open.title')}
              </Column>
              <Column col6 noPadding>
                {getText('payApply.applicationRejected.support.open.hours')
                  .split(',')
                  .map(text => (
                    <div key={text}>{text}</div>
                  ))}
              </Column>
            </Columns>
          </Column>
        </Columns>
      </div>
    </PageWrapper>
    <PageWrapper>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '2rem',
        }}
      >
        <Button onClick={() => onCancel()}>
          {getText('payApply.restart')}
        </Button>
        <Button
          id="application-reject-btn"
          type="primary"
          onClick={() => {
            onNext()
          }}
        >
          {getText('payApply.logout')}
        </Button>
      </div>
    </PageWrapper>
  </>
)

ApplicationRejectedPage.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
}

export default ApplicationRejectedPage
